import { render } from "./MensagensAutomaticas.vue?vue&type=template&id=0da7faa1&scoped=true"
import script from "./MensagensAutomaticas.vue?vue&type=script&lang=js"
export * from "./MensagensAutomaticas.vue?vue&type=script&lang=js"

import "./MensagensAutomaticas.vue?vue&type=style&index=0&id=0da7faa1&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da7faa1"]])

export default __exports__